var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.8 6.83128L12 8.02605L6 14L-3.5083e-07 8.02605L1.19998 6.83128L5.15147 10.7656L5.15147 -2.99359e-07L6.84853 -2.25178e-07L6.84853 10.7656L10.8 6.83128Z","fill":"#35459C"}));
}

ArrowDown.defaultProps = {"width":"12","height":"14","viewBox":"0 0 12 14","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
